import React from "react";
import { ButtonDS } from "get-life-storybook-ts";
import V3PriceDisplay from "./V3PriceDisplay";

interface V3StickyCTAProps {
  translate: (key: string) => string;
  amount: number;
  loading: boolean;
  activeCount: number;
  hidden: boolean;
  onClick: () => void;
}

const V3StickyCTA: React.FC<V3StickyCTAProps> = ({
  translate,
  amount,
  loading,
  activeCount,
  hidden,
  onClick,
}) => {
  return (
    <div
      className={`upsell-v3__sticky${hidden ? " upsell-v3__sticky--hidden" : ""}`}
      role="region"
      aria-label="Resumen de precio"
    >
      <div className="upsell-v3__sticky-info">
        <span className="label">
          {translate("newUpsell.v3.sticky.coveragesLabel").replace(
            "{count}",
            String(activeCount)
          )}
        </span>
        <V3PriceDisplay amount={amount} loading={loading} size={22} suffix="/mes" />
      </div>
      <div className="upsell-v3__sticky-button">
        <ButtonDS
          label={translate("newUpsell.v3.sticky.cta")}
          onClick={onClick}
          rightIcon="ArrowRightIcon"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default V3StickyCTA;
